import React, { useState, useRef } from 'react';
import { Upload, X } from 'lucide-react';

const MultipleImageUpload = ({ onChange }) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    addImages(files);
  };

const addImages = (files) => {
  const newImages = files.map(file => ({
    file,
    preview: URL.createObjectURL(file),
    id: Math.random().toString(36).substr(2, 9)
  }));

  setSelectedImages(prev => {
    const updated = [...prev, ...newImages];
    onChange?.(updated.map(img => img.file)); // ✅ SEND FILES UP
    return updated;
  });
};

const removeImage = (id) => {
  setSelectedImages(prev => {
    const updated = prev.filter(img => img.id !== id);
    onChange?.(updated.map(img => img.file)); // ✅ UPDATE PARENT
    return updated;
  });
};


  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files).filter(file => 
      file.type.startsWith('image/')
    );
    addImages(files);
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };



  return (
    <>
      <style>{`
        .MUL_container {
          
          background-color: #f9fafb;
          padding: 2rem;
        }

        .MUL_wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .MUL_title {
          font-size: 1.875rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 2rem;
        }

        .MUL_upload_area {
          position: relative;
          border: 2px dashed #d1d5db;
          border-radius: 0.5rem;
          background-color: white;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .MUL_upload_area_empty {
          padding: 3rem;
        }

        .MUL_upload_area_filled {
          padding: 1.5rem;
        }

        .MUL_upload_area_dragging {
          border-color: #f97316;
          background-color: #fff7ed;
        }

        .MUL_file_input {
          display: none;
        }

        .MUL_empty_state {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }

        .MUL_icon_wrapper {
          width: 4rem;
          height: 4rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .MUL_upload_icon {
          color: #f97316;
        }

        .MUL_upload_text {
          font-size: 1.25rem;
          color: #374151;
          text-align: center;
        }

        .MUL_browse_link {
          color: #f97316;
          font-weight: 500;
          text-decoration: underline;
        }

        .MUL_browse_link:hover {
          color: #ea580c;
        }

        .MUL_file_info {
          font-size: 0.875rem;
          color: #6b7280;
          margin-top: 0.5rem;
          text-align: center;
        }

        .MUL_image_grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
        }

        @media (min-width: 640px) {
          .MUL_image_grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (min-width: 768px) {
          .MUL_image_grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .MUL_image_grid {
            grid-template-columns: repeat(6, 1fr);
          }
        }

        .MUL_image_item {
          position: relative;
          aspect-ratio: 1;
          border-radius: 1rem;
          overflow: hidden;
          background-color: white;
        }

        .MUL_image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .MUL_remove_button {
            position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 2rem;
    height: 2rem;
    background-color: red;
    border-radius: 50%;
    display: flex
;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    border: none;
    color: white;
        }

        .MUL_image_item:hover .MUL_remove_button {
          opacity: 1;
        }

        .MUL_remove_button:hover {
          background-color: red;
          color:white
        }

        .MUL_submit_wrapper {
          display: flex;
          justify-content: center;
          margin-top: 1.5rem;
        }

        .MUL_submit_button {
          padding: 0.75rem 2rem;
          background-color: #f97316;
          color: white;
          font-weight: 500;
          border: none;
          border-radius: 0.5rem;
          cursor: pointer;
          transition: background-color 0.2s ease;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .MUL_submit_button:hover {
          background-color: #ea580c;
        }
      `}</style>

      <div className="MUL_container">
        <div className="MUL_wrapper">
         
          <div>
            <div
              className={`MUL_upload_area ${
                selectedImages.length > 0 
                  ? 'MUL_upload_area_filled' 
                  : 'MUL_upload_area_empty'
              } ${isDragging ? 'MUL_upload_area_dragging' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={handleBrowseClick}
            >
              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept="image/png,image/jpeg,image/jpg,image/gif"
                onChange={handleImageChange}
                className="MUL_file_input"
              />

              {selectedImages.length === 0 ? (
                <div className="MUL_empty_state">
                  <div className="MUL_icon_wrapper">
                    <Upload className="MUL_upload_icon" size={48} strokeWidth={2} />
                  </div>

                  <div>
                    <p className="MUL_upload_text">
                      Drop your images here, or{' '}
                      <span className="MUL_browse_link">
                        click to browse
                      </span>
                    </p>
                
                  </div>
                </div>
              ) : (
                <div className="MUL_image_grid">
                  {selectedImages.map((image) => (
                    <div
                      key={image.id}
                      className="MUL_image_item"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <img
                        src={image.preview}
                        alt="Preview"
                        className="MUL_image"
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeImage(image.id);
                        }}
                        className="MUL_remove_button"
                        aria-label="Remove image"
                      >
                        <X size={20} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

    
          </div>
        </div>
      </div>
    </>
  );
};

export default MultipleImageUpload;